import { render, staticRenderFns } from "./giftInfo.vue?vue&type=template&id=3b854740&scoped=true&"
import script from "./giftInfo.vue?vue&type=script&lang=js&"
export * from "./giftInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b854740",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b854740')) {
      api.createRecord('3b854740', component.options)
    } else {
      api.reload('3b854740', component.options)
    }
    module.hot.accept("./giftInfo.vue?vue&type=template&id=3b854740&scoped=true&", function () {
      api.rerender('3b854740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/product/proManage/giftInfo.vue"
export default component.exports